module.exports = __webpack_public_path__ + "img/60000.87fc6e3d.jpg";